import { mapChat } from '../../../mappers';
import { IModalWarning } from '../../../repositories/chats/entities/spam_modal_warning/ModalWarning';
import { ISyncChatV31 } from '../../../repositories/chats/entities/synchronization_v3/SyncChatV31';
import { DEFAULT_ERROR_MESSAGE } from '../constants';
import { EFirstMessageResponseStatus, TFirstMessageResponse } from '../types';

interface IFirstMessageV4Response {
  chat?: ISyncChatV31 | null;
  modalWarning?: IModalWarning | null;
}

export const map200Response = ({ chat, modalWarning }: IFirstMessageV4Response): TFirstMessageResponse => {
  if (chat && chat.chatId) {
    return {
      status: EFirstMessageResponseStatus.Success,
      data: mapChat(chat),
    };
  }

  if (chat && chat.status === 'blocked') {
    return {
      status: EFirstMessageResponseStatus.Blocked,
    };
  }

  if (modalWarning) {
    return {
      status: EFirstMessageResponseStatus.ForbiddenText,
      data: modalWarning,
    };
  }

  return { status: EFirstMessageResponseStatus.UnknownError, data: { message: DEFAULT_ERROR_MESSAGE } };
};
